import { Provider } from 'react-redux';
import React, { Component } from 'react';
import { ApolloProvider } from 'react-apollo';
import { withProvider } from '@tcaster/tcaster-web-lib';
import { createGlobalStyle } from 'styled-components';

import RouteApp from './Routes/Main';
import store from './Redux/store';
import apolloClient from './GraphQL';
import { theme } from './Components/Theme';
import FacebookProvider from './Util/HOC/FacebookSDK';
import { getConfig } from './Util/Config';

const RouteAppWithRebass = withProvider(RouteApp, theme);
const fbAppId = getConfig().facebookAppId;

const GlobalStyle = createGlobalStyle`
  * { box-sizing: border-box; }

  html {
    padding-top: 60px;
  }

  body,
  #app,
  #app > * {
    height: 100%;
  }

  body {
    font-size: 16px;
  }
`;

class App extends Component {
  render() {
    return (
      <FacebookProvider appId={fbAppId}>
        <ApolloProvider client={apolloClient}>
          <Provider store={store}>
            <React.Fragment>
              <GlobalStyle />
              <RouteAppWithRebass />
            </React.Fragment>
          </Provider>
        </ApolloProvider>
      </FacebookProvider>
    );
  }
}

export default App;
